import { ApiError } from "../api";
import { translateKey } from "../i18n";
import { isPublicErrorCode, normalizePublicErrorInput, type PublicError } from "@nexra/contracts";

export function publicErrorMessage(error: { code: string }): string {
  return translateKey(`publicErrors.${isPublicErrorCode(error.code) ? error.code : "internal_error"}`);
}

export function publicApiError(error: unknown): PublicError | undefined {
  if (!(error instanceof ApiError)) return undefined;
  const normalized = error.publicError ?? normalizePublicErrorInput(error);
  return normalized && isPublicErrorCode(normalized.nexraError.code) ? normalized : undefined;
}

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError && error.code !== undefined) return publicErrorMessage({ code: error.code });
  if (error instanceof ApiError && error.status === 401) return translateKey("workspace.needSignIn");
  if (error instanceof Error) {
    if (/failed to fetch|fetch failed|networkerror|network request failed|load failed/i.test(error.message)) return translateKey("common.networkError");
    return error.message;
  }
  return translateKey("common.loadFailed");
}
